module.exports = require("@gauzy/plugin-job-proposal");